import * as React from "react"
const FileAttachmentIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 32 }
        height={ 40 }
        fill="none"
        { ...props }
    >
        <path
            stroke="#338AFF"
            strokeWidth={ 2 }
            d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
        />
        <path stroke="#338AFF" strokeWidth={ 2 } d="M11 2v9a1 1 0 0 1-1 1H2" />
        <path
            fill="#338AFF"
            fillRule="evenodd"
            d="M21.78 17.145a3.818 3.818 0 0 0-1.765-1.014 3.955 3.955 0 0 0-2.02 0 3.761 3.761 0 0 0-1.767 1.014l-6.682 6.682a5.141 5.141 0 0 0-1.37 2.376 5.303 5.303 0 0 0 0 2.709 5.14 5.14 0 0 0 1.37 2.375 5.14 5.14 0 0 0 2.376 1.37 5.302 5.302 0 0 0 2.709 0 5.14 5.14 0 0 0 2.375-1.37l5.922-5.922a.5.5 0 0 0 0-.707l-.707-.707a.5.5 0 0 0-.707 0l-5.922 5.922a3.168 3.168 0 0 1-1.469.845 3.306 3.306 0 0 1-1.694 0 3.169 3.169 0 0 1-1.469-.845 3.168 3.168 0 0 1-.844-1.468 3.305 3.305 0 0 1 0-1.695c.146-.563.427-1.05.844-1.468l6.682-6.683c.249-.248.532-.408.853-.486l.005-.002c.339-.088.67-.091.997-.012.333.087.62.253.868.5.248.249.408.531.487.853l.001.005c.088.337.088.67 0 1.007l-.001.005a1.784 1.784 0 0 1-.487.853l-6.046 6.046a.56.56 0 0 1-.42.172.53.53 0 0 1-.393-.172.592.592 0 0 1-.185-.407.591.591 0 0 1 .185-.407l5.286-5.285a.5.5 0 0 0 0-.707l-.708-.707a.5.5 0 0 0-.707 0L12.092 25.1c-.33.33-.554.72-.67 1.166l-.002.005a2.702 2.702 0 0 0 0 1.3l.002.005c.116.447.34.837.67 1.166.328.328.715.55 1.155.658.44.114.88.12 1.316.013l.004-.001a2.527 2.527 0 0 0 1.166-.67l6.046-6.046a3.756 3.756 0 0 0 1.014-1.766 3.956 3.956 0 0 0 0-2.02 3.819 3.819 0 0 0-1.014-1.765Z"
            clipRule="evenodd"
        />
    </svg>
)
export default FileAttachmentIcon
